<template>
    <div>        
            <slot></slot>
       
    </div>

</template>
<script>
export default {


}
</script>




// WEBPACK FOOTER //
// ClientApp/calendar/layout.vue